{
  "slug": "is-iq-genetic",
  "title": "هل معدل الذكاء وراثي؟",
  "description": "تعلم كيف تسهم الجينات والبيئة في الاختلافات المعرفية، وماذا تعني - وما لا تعني - القابلية للوراثة.",
  "summary": "وتتأثر القدرة المعرفية بالعديد من الاختلافات الجينية والعديد من العوامل البيئية، وتتفاعل هذه العوامل طوال فترة النمو.",
  "sections": [
    {
      "heading": "العديد من التأثيرات، وليس جين واحد لمعدل الذكاء",
      "paragraphs": [
        "إن الاختلافات الجينية تساهم في الاختلاف في درجات الاختبارات المعرفية، ولكن لا يوجد جين واحد يحدد معدل الذكاء لدى الشخص. والواقع أن التأثيرات موزعة على العديد من المتغيرات، وكل منها لا يساهم عادة إلا بالقليل للغاية.",
        "إن علم الأحياء يتطور في بيئة معينة. ومن الممكن أن تؤثر عوامل التغذية، والصحة، والتعليم، والسلامة، والإجهاد، والموارد الأسرية، والفرص على كيفية تطور المهارات المعرفية والتعبير عنها."
      ]
    },
    {
      "heading": "ماذا تعني القابلية للوراثة",
      "paragraphs": [
        "إن القابلية للوراثة هي إحصائية سكانية تصف مقدار الاختلاف الملاحظ المرتبط بالاختلافات الجينية في ظل ظروف معينة. وهي لا تقول لنا ما هي النسبة المئوية من ذكاء شخص ما التي ترجع إلى العوامل الجينية.",
        "قد تكون السمة وراثية وتظل مستجيبة للتغير البيئي. وتختلف التقديرات عبر الأعمار، والسكان، والظروف الاجتماعية."
      ]
    },
    {
      "heading": "تجنب الاستنتاجات الحتمية",
      "paragraphs": [
        "إن نتيجة الحمض النووي لا يمكن أن توفر تنبؤاً كاملاً أو نهائياً بالمستقبل المعرفي للفرد. ولا يمكن لمتوسطات المجموعات أن تحدد إمكانات الفرد.",
        "إن البيئات الداعمة، والتعليم الفعّال، والرعاية الصحية، والفرص تظل ذات أهمية. ولا يستخدم التفسير المسؤول أبداً معدل الذكاء لتصنيف القيمة الإنسانية."
      ]
    }
  ],
  "faqs": [
    {
      "question": "كم من معدل الذكاء موروث؟",
      "answer": "ولا توجد نسبة مئوية واحدة للفرد، وتختلف تقديرات السكان حسب العمر والبيئة والسكان وطريقة الدراسة."
    },
    {
      "question": "هل تؤثر البيئة على معدل الذكاء؟",
      "answer": "نعم، يمكن للتعليم والصحة والتغذية والإجهاد واللغة والفرص أن تؤثر على النمو وأداء الاختبارات."
    }
  ],
  "related": ["can-iq-change-over-time", "what-is-iq", "iq-vs-intelligence"]
}
